export { default as XCircleIcon } from './XCircleIcon';
